// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__FxQNe","disableBtn":"style_disableBtn__jvUVb","false":"style_false__6rqYJ","right":"style_right__oGS-5","disable":"style_disable__ianYN"};